/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  /** Data de entrega do empreendimento de origem, no formato yyyy-MM-dd. */
  dataEntrega?: string | null;
  enabled?: boolean;
}

/**
 * Lista os empreendimentos elegíveis para cópia de proposta.
 *
 * O backend filtra pela data de entrega informada, de forma que só retornam
 * empreendimentos ativos cuja entrega coincide com a da unidade de origem.
 */
export function useGetEmpreendimentosCopiaProposta(props: Props) {
  const GET_EMPREENDIMENTOS = `${backofficeEnviroment}/common/oportunidades-lead/copia-proposta/empreendimentos/v1`;

  const fetchData = async () => {
    const response = await instance.get(GET_EMPREENDIMENTOS, {
      params: { dataEntrega: props.dataEntrega },
    });
    return response?.data?.data;
  };

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["copia-proposta-empreendimentos", props.dataEntrega],
    refetchOnWindowFocus: false,
    enabled: Boolean(props.enabled && props.dataEntrega),
    onError: (error: any) => {
      notificarErroApi("Erro ao buscar empreendimentos", error);
    },
  });

  return query;
}
